"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCKET_URL = exports.PATH_TO_WASM = void 0;
exports.PATH_TO_WASM = 'https://websdk1.blob.core.windows.net/sdk-1-2-3/';
exports.SOCKET_URL = 'wss://rppg-dev2.xyz/vp/bgr_signal_socket';
//# sourceMappingURL=api.js.map